 <template>
    <main id="homeSection" class="mainContentAdmin">
      <!-- <mainHeader  /> -->
      <section id="homeLeader">
      <headerSticky />
    </section>
      <section
      v-if="
        (homeData.slidersCalibrationLab.length > 0 && $root.sectionIndexHome == 1) ||
        (homeData.slidersCalibrationLab.length > 0 && $root.screenSize < 1000)
      "
      id="sliderSection"
      class="d-flex width100 height100vh"
    >
      <slider :slider="homeData.slidersCalibrationLab" class="width100  " />
      </section>
      <!-- <div id="titles" class="d-flex flex-direction-column ">
          <h1>آزمایشگاه کالیبراسیون مارگارين</h1>
          <p>
            مارگارين اولين شركت توليد كننده روغن گياهي در ايران است كه با برندهای خروس، آفتاب و آفتاب طلايي در بين مردم شناخته شده است. اين شركت كه در دی ماه سال 1332 با ظرفیت تصفيه 8 تن روغن گياهي در روز پا به عرصه صنعت گذاشت و اکنون با همكاري كارشناسان مجرب توانسته است با ظرفیت توليدي 1000 تن در روز، میهمان بسیاری ازخانواده¬ها و صنایع مختلف کشور باشد.
          </p>
          <p>
            آزمايشگاه كاليبراسيون مارگارين از سال 1378 به عنوان زير مجموعه واحد برق كارخانه شروع به فعاليت كرد سپس با توجه به الزامات سازمان غذا و دارو و استاندارد هاي بين المللي نظير Codex و Iso 9001 به منظور حفظ سلامتي محصول، ايمني پرسنل و تجهيزات و با ماموريت كاليبراسيون بيش از 1000 تجهيز در سطح كارخانه براساس استاندارد هاي معتبر به عنوان يك واحد فرايندي مجزا مورد بهره برداري قرار گرفت.
          </p>
          <p>به دنبال ارتقاي عمليات فني پشتيباني كننده محصولات و با توجه به پتانسيل هاي موجود از قبيل نيروي انساني ماهر و امكانات به روز ، مديريت فني كارخانه ايجاد آزمايشگاه كاليبراسيون معتبر را در دستور كار قرار داد و در سال 1402 موفق به اخذ گواهينامه Iso 17025 شد تا از اين طريق امكان ارايه خدمات كاليبراسيون به ساير ارگان ها ، كارخانجات و شركت ها فراهم گردد.</p>
          <p> ما به كيفيت، دقت و انطباق با استاندارد ها متعد هستيم و در راستاي ارايه خدمات كاليبراسيون با بالاترين استاندارد ها تلاش مي كنيم.</p>
        </div> -->
      <!-- <healthFooter  class="hiddenInMobile" />
      <mainFooter  class="showInMobile" /> -->
      <!-- <mainFooter  class="showInMobile" /> -->
      
    </main>

  </template>
  <script>
 // import mainHeader from "@/components/front/home/slider/headerCalibrationLab.vue";
  //import footerNavigation from "@/components/front/shared/footerNavigation.vue";
 // import virtualTour from "@/components/front/healthAmbassador/virtualTour.vue";
 // import statistics from "@/components/front/healthAmbassador/statistics.vue";
  //import application from "@/components/front/healthAmbassador/application.vue";
  //import mainFooter from "@/components/front/shared/footer.vue";
  //import healthFooter from "@/components/front/healthAmbassador/mainFooter.vue";
 // import slider from "@/components/front/home/slider.vue";
 import slider from "@/components/front/home/sliderCalibrationLab.vue";
 import headerSticky from "@/components/front/home/slider/headerCalibrationLab.vue";
  export default {
    components: {
     headerSticky,
    //  mainHeader,
      //virtualTour,
      //statistics,
      //application,
     // healthFooter,
     // mainFooter,
      slider,
     // footerNavigation
    },
    data() {
      return {
        // healthAmbassador: {
        //   virtualTour: {
        //     image: "https://s4.uupload.ir/files/layer_2661_copy_3_buj.png",
        //     title: "تور مجازی بازدید از خط تولید",
        //     summary: "کیفیت و برتری با  مارگارین"
        //   },
        //   statistics: {
        //     title: "بـــــــا مـــــــا همـــــــراه شویـــــــد",
        //     summary: "آمــــــــار و ارقــــــــام مجموعــــــــه مــــــــا",
        //     list: [
        //       {
        //         title: "شرکت مارگارین",
        //         summary: "فروش بیشتر امسال",
        //         image: "https://s4.uupload.ir/files/group_1_b9ww.png"
        //       },
        //       {
        //         title: "شرکت مارگارین",
        //         summary: "بازدهی کارکنان ما",
        //         image: "https://s4.uupload.ir/files/group_298_pfi6.png"
        //       },
        //       {
        //         title: "شرکت مارگارین",
        //         summary: "افزایش خطوط تولید",
        //         image: "https://s4.uupload.ir/files/group_2401_es6c.png"
        //       }
        //     ]
        //   },
        //   application: {
        //     title: "همیشـــــــه در کـــــــنار شـــــــما",
        //     summary: "دریــــــــافت اپلیکیشـــــــــــن",
        //     iosRoute: "google.com",
        //     logos: "https://s4.uupload.ir/files/logo_mjtw.png",
        //     image: "https://s4.uupload.ir/files/group_2mobile_e7ai.png",
        //     androidRoute: "foo.com"
        //   },
      
        // }
      };
    },
    //      metaInfo() {
    //   return {
    //     title: this.$cookie.get("ltrTheme") ? "Margarine Calibration Lab" : "مارگارین - آزمايشگاه كاليبراسيون ",
    //     meta: [
    //       {
    //         name: "description",
    //         content: "مارگارین  آزمايشگاه كاليبراسيون"
    //       },
    //       {
    //         property: "og:title",
    //         content: this.$cookie.get("ltrTheme") ? "Margarine Calibration Lab" : "مارگارین -  آزمايشگاه كاليبراسيون"
    //       },
    //       { name: "robots", content: "index,follow" }
    //     ]
    //   };
    // },
    metaInfo() {
    return {
      title: this.$cookie.get("ltrTheme") ? "Margarine Calibration Lab" : "مارگارین - آزمايشگاه كاليبراسيون ",
      meta: [
        {
          name: "description",
          content: this.footerData ? this.footerData.meta : "آزمايشگاه كاليبراسيون مارگارین"
        },
        {
          property: "og:title",
          content: this.$cookie.get("ltrTheme") ? "Margarine Calibration Lab" : "مارگارین -  آزمايشگاه كاليبراسيون"
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  },
    computed:{
      homeData(){
        return this.$store.getters.getHomeData;
  
      }
    },
    created(){
      if (this.homeData == null) {
        this.checkRequest('getHomeDataFromServer',JSON.stringify(null));
        
      }
    },
    mounted() {
   // window.addEventListener("resize", this.setStyle);
  //  window.addEventListener("keydown", this.showSection);
   // window.addEventListener("wheel", this.showSectionWithScroll);
  },
  beforeDestroy() {
   // window.removeEventListener("wheel", this.showSectionWithScroll);
    //window.removeEventListener("keydown", this.showSection);
    //window.removeEventListener("resize", this.setStyle);
  },
    methods: {
    //   showSectionWithScroll(event) {
    //   if (this.$root.footerMapCursor != true) {
    //     let oldLastWheel = this.lastWheel;
    //     this.lastWheel = event.deltaY;
    //     if (oldLastWheel > 0 && this.lastWheel > 0) {
    //       this.wheelCounter++;
    //     } else if (oldLastWheel < 0 && this.lastWheel < 0) {
    //       this.wheelCounter--;
    //     } else {
    //       this.wheelCounter = 0;
    //     }
    //     if (this.wheelCounter == 2) {
    //       this.wheelCounter = 0;
    //       if (this.$root.sectionIndexHome != 8) {
    //         this.$root.sectionIndexHome++;
    //       }
    //       window.removeEventListener("wheel", this.showSectionWithScroll);
    //       setTimeout(() => {
    //         window.addEventListener("wheel", this.showSectionWithScroll);
    //       }, 2000);
    //     }
    //     if (this.wheelCounter == -2) {
    //       this.wheelCounter = 0;
    //       if (this.$root.sectionIndexHome != 1) {
    //         this.$root.sectionIndexHome--;
    //       }
    //       window.removeEventListener("wheel", this.showSectionWithScroll);
    //       setTimeout(() => {
    //         window.addEventListener("wheel", this.showSectionWithScroll);
    //       }, 2000);
    //     }
    //     // increase speed of website with preFetchData
    //     if (this.sectionIndexHome == 4) {
    //       let pack = {
    //         page: this.$route.query.page ? this.$route.query.page : 1,
    //         isDesending: this.$route.query.isDesending
    //           ? this.$route.query.isDesending
    //           : true,
    //         category: this.$route.query.category
    //           ? this.$route.query.category
    //           : "",
    //         search: this.$route.query.search ? this.$route.query.search : ""
    //       };
    //       // this.$store.dispatch("getCookingsFromServer", pack);
    //       this.checkRequest("getCookingsFromServer", JSON.stringify(pack));
    //     }
    //   }
    // },
    // showSection(e) {
    //   if (e.key == "8" || e.key == "ArrowUp") {
    //     if (this.$root.sectionIndexHome != 1) {
    //       this.$root.sectionIndexHome--;
    //     }
    //   }
    //   if (e.key == "2" || e.key == "ArrowDown") {
    //     if (this.$root.sectionIndexHome != 8) {
    //       this.$root.sectionIndexHome++;
    //     }
    //   }
    // },
    // gotoLink(link) {
    //   if (link == null) return;
    //   window.open(link, "_blank");
    // },
      // setStyle() {
      //   if (window.innerWidth > 1000) {
      //     if(window.innerWidth>1500){
      //       this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #shopSection #content #titles #roundedButton",
      //       1920,
      //       35,
      //       1440,
      //       60
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #tour #content #seeTour span",
      //       1920,
      //       23,
      //       1440,
      //       14
      //     );
          
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #ourProduct #carts .ourProductCart p",
      //       1920,
      //       18,
      //       1440,
      //       12
      //     );
          
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #goodFamily #content .choose button",
      //       1920,
      //       19,
      //       1440,
      //       13
      //     );
      //       this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection .blogCart .innerContent .content h1",
      //       1920,
      //       22,
      //       1440,
      //       18
      //     );
          
      //       this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection .blogCart .innerContent .content h5",
      //       1920,
      //       14,
      //       1440,
      //       10
      //     );
          
      //       this.$root.setProportionStyle(
      //       "margin-top",
      //       "%",
      //       "#healthAmbassador #blogsSection .blogCart .innerContent .content .breaker",
      //       1920,
      //       7,
      //       1440,
      //       15
      //     );
      //      this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection .blogCart .innerContent .content .detail span",
      //       1920,
      //       17,
      //       1440,
      //       13
      //     );
      //     }else{
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #headerContent #navBarMenu ul li a",
      //       1440,
      //       16,
      //       1013,
      //       11
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #shopSection #content #titles h1",
      //       1440,
      //       34,
      //       1013,
      //       25
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #shopSection #content #titles h3",
      //       1440,
      //       42,
      //       1013,
      //       34
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #shopSection #content #titles #roundedButton",
      //       1440,
      //       60,
      //       1013,
      //       67
      //     );
      //     this.$root.setProportionStyle(
      //       "margin-top",
      //       "%",
      //       "#healthAmbassador #tour",
      //       1440,
      //       10,
      //       1013,
      //       14
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #tour img",
      //       1440,
      //       40,
      //       1013,
      //       47
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #tour #content h1",
      //       1440,
      //       30,
      //       1013,
      //       26
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #tour #content h3",
      //       1440,
      //       44,
      //       1013,
      //       30
      //     );
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #tour #content #seeTour",
      //       1440,
      //       45,
      //       1013,
      //       58
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #ourProduct h3",
      //       1440,
      //       44,
      //       1013,
      //       39
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #ourProduct h1",
      //       1440,
      //       30,
      //       1013,
      //       26
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#goodFamily #content",
      //       1440,
      //       40,
      //       1013,
      //       50
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #goodFamily #content .choose",
      //       1440,
      //       80,
      //       1013,
      //       91
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #goodFamily #content h1",
      //       1440,
      //       30,
      //       1013,
      //       26
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #goodFamily #content h3",
      //       1440,
      //       26,
      //       1013,
      //       23
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "div#carts .cartStatistics img",
      //       1440,
      //       66,
      //       1013,
      //       52
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #application #content h2",
      //       1440,
      //       28,
      //       1013,
      //       24
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #application #content h1",
      //       1440,
      //       38,
      //       1013,
      //       30
      //     );
  
      //     this.$root.setProportionStyle(
      //       "margin-top",
      //       "px",
      //       "#healthAmbassador #application #content #routes",
      //       1440,
      //       50,
      //       1013,
      //       25
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #application #content #routes a div span:last-child",
      //       1440,
      //       12,
      //       1013,
      //       8
      //     );
  
      //     this.$root.setProportionStyle(
      //       "bottom",
      //       "px",
      //       "#healthAmbassador #application div#logos",
      //       1440,
      //       -118,
      //       1013,
      //       -90
      //     );
      //     this.$root.setProportionStyle(
      //       "margin-bottom",
      //       "px",
      //       "#healthAmbassador #application ",
      //       1440,
      //       70,
      //       1013,
      //       46
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection h1",
      //       1440,
      //       28,
      //       1013,
      //       25
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection h2",
      //       1440,
      //       38,
      //       1013,
      //       29
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection .blogCart .innerContent .content h1",
      //       1440,
      //       18,
      //       1013,
      //       16
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection .blogCart .innerContent .content .detail span",
      //       1440,
      //       13,
      //       1013,
      //       11
      //     );
      //     }
      //   } else {
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador .mainLogo",
      //       999,
      //       8,
      //       425,
      //       15
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #shopSection #content #titles h1",
      //       999,
      //       34,
      //       425,
      //       23
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #shopSection #content #titles h3",
      //       999,
      //       42,
      //       425,
      //       25
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #shopSection #content img",
      //       999,
      //       60,
      //       425,
      //       90
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #shopSection #content #titles #roundedButton",
      //       999,
      //       36,
      //       425,
      //       70
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #shopSection #content #titles #roundedButton",
      //       999,
      //       18,
      //       425,
      //       14
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #tour #content h1",
      //       999,
      //       30,
      //       425,
      //       18
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #tour #content h3",
      //       999,
      //       44,
      //       425,
      //       23
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #tour #content #seeTour",
      //       999,
      //       32,
      //       425,
      //       72
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #tour img",
      //       999,
      //       60,
      //       425,
      //       90
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #ourProduct h1",
      //       999,
      //       26,
      //       425,
      //       18
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #ourProduct h3",
      //       999,
      //       37,
      //       425,
      //       21
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #goodFamily #content .choose",
      //       999,
      //       55,
      //       425,
      //       95
      //     );
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #goodFamily #content .choose button",
      //       999,
      //       13,
      //       425,
      //       9
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #goodFamily #content h3",
      //       999,
      //       24,
      //       425,
      //       17
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #goodFamily #content h1",
      //       999,
      //       30,
      //       425,
      //       21
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #goodFamily img",
      //       999,
      //       56,
      //       425,
      //       95
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #statisticsSection h1",
      //       999,
      //       26,
      //       425,
      //       16
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #statisticsSection h3",
      //       999,
      //       36,
      //       425,
      //       23
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #application #content h2",
      //       999,
      //       24,
      //       425,
      //       17
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #application #content h1",
      //       999,
      //       32,
      //       425,
      //       25
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #application #content #routes a div span:last-child",
      //       999,
      //       12,
      //       425,
      //       10
      //     );
  
      //     this.$root.setProportionStyle(
      //       "margin-top",
      //       "px",
      //       "#healthAmbassador #application #content #routes",
      //       999,
      //       50,
      //       425,
      //       30
      //     );
      //     this.$root.setProportionStyle(
      //       "margin-bottom",
      //       "px",
      //       "#healthAmbassador #application #content #routes",
      //       999,
      //       1,
      //       425,
      //       15
      //     );
  
      //     this.$root.setProportionStyle(
      //       "width",
      //       "%",
      //       "#healthAmbassador #application div#logos",
      //       999,
      //       150,
      //       425,
      //       370
      //     );
          
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection h1",
      //       999,
      //       26,
      //       425,
      //       20
      //     );
  
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection h2",
      //       999,
      //       33,
      //       425,
      //       22
      //     );
          
      //     this.$root.setProportionStyle(
      //       "font-size",
      //       "px",
      //       "#healthAmbassador #blogsSection .blogCart .innerContent .content .detail span",
      //       999,
      //       13,
      //       425,
      //       9
      //     );
          
      //   }
      // }
    }
  };
  </script> 

   <style scoped>
   .mainContentAdmin {
      padding: 0;
     }
     #homeSection #homeLeader #headerContent {
    position: absolute;
    right: 20% !important;
    top: 2%;
    z-index: 10;
    width: 80% !important;
}
     /* .mainContentAdmin #headerContent #navBarMenu{
      margin-right: 230px !important;
     }
     .mainContentAdmin #headerContent .mainLogo {
     display: none !important;
    } */
    /* #healthAmbassador  {
      overflow-y:hidden;

    }
    #healthAmbassador #sliderContent  #slider {
      object-fit:  contain;
      overflow-y:hidden; 
    } */
    /* #sliderSection #sliderContent #slider .sliderItem img important{
    width: 100%;
    height: 70vh;
    -o-object-fit: cover;
    object-fit: cover;
} */


     /* #titles{
    padding-left: 40px;
    padding-right: 40px;
    align-items: center;
     justify-content: right; 
    margin-top: 100px;
    margin-left: 70px;
    margin-right: 70px;
  } */
  </style> 
   